module.exports = __webpack_public_path__ + "static/tort-reform-5ceff902af75f02e42e219e652f69c10.jpg";